const en = require('./en.json');
const ptBr = require('./pt-BR.json');

const myIssues = {
  en,
  ptBr,
}

export {
  myIssues
};